// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_k0-0";
export var buttonContainer = "_k0-3";
export var cancelButton = "_k0-4";
export var headerSection = "_k0-6";
export var headerTitle = "_k0-9";
export var messageSideLeft = "_k0-1";
export var messageSideRight = "_k0-2";
export var orderNumberContainer = "_k0-7";
export var orderNumberLabel = "_k0-8";
export var submitButton = "_k0-5";